/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { AssetId, AssetSet } from "types/Asset";
import { PlaylistClip } from "types/Clip";
import { TypedEventTarget } from "typescript-event-target";

export interface AudioPlayerEventMap {
  stateChanged: CustomEvent<AudioPlayerState>;
}

export enum AudioPlayerState {
  playing = "playing",
  paused = "paused",
  buffering = "buffering",
}

export interface AudioPlayer extends TypedEventTarget<AudioPlayerEventMap> {
  setPlaybackCompleteCallback(callback: () => void): void;

  updateAssets(assets: AssetSet): Promise<void>;

  updatePlaylist(playlist: PlaylistClip[]): Promise<void>;

  play(): Promise<void>;

  pause(): Promise<void>;

  seek(seekTime: number): Promise<void>;

  reset(): Promise<void>;

  loadLocalAsset(assetId: AssetId, blob: Blob): Promise<AudioBuffer | null>;

  // TODO: Move this to a separate interface?
  getAssetAudioBuffer(
    assetId: AssetId
  ): Promise<AudioBuffer | null> | undefined;
}
